/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 *
 * @flow
 */

import React from 'react';
import Loader from 'react-loader-spinner';
import styles from './PopupContent.module.css';
import Button from '../../Button';
import strings from "../../../globalization";

const defaultColor = '#AD0028';

const PopupContent = props => {
  const { type, themeColor = defaultColor } = props;
  if (type === 'spinner') {
    const { heading, message, buttons } = props;
    return (
      <div className={styles.spinnerOuterContainer}>
      <div className={styles.spinnerContainer}  >
        <div style={{ display: 'flex', marginRight: '10px' }}>
          <Loader
            type="Oval"
            color={themeColor}
            height="50"
            width="50"
            style={{ marginRight: '10px' }}
          />
        </div>
        <div className={styles.spinnerMessageContainer}>
          <span className={styles.spinnerHeading}>{heading}</span>
          <span className={styles.spinnerMessage}>{message}</span>
        </div>
        </div>
        {buttons ? (<div  className={styles.notificationButtons} >
          {buttons.map((button, index) => (
            <Button
              key={`popup-button-${button.text}`}
              style={{
                background: 'white',
                flex: 1,
              }}
              onClick={button.onClick}
            >
              <span className={styles.cancelText} style={{ color: themeColor }}>{button.text}</span>
            </Button>
          ))} 
        </div>) : null}
      </div>
    );
  }
  if (type === 'popup') {
    const { heading, message, buttons } = props;
    let eMsg = strings.errorPopupDefaultMessage;
    let sMsg = '', errorConfMsg = '';
    if (typeof message === 'object' || message instanceof Object) {
      const { errorMessage, supportMessage, message: errMsg, errorConfirmationMsg } = message;
      eMsg = errMsg || errorMessage || strings.errorPopupDefaultMessage;
      sMsg = supportMessage;
      errorConfMsg = errorConfirmationMsg;
    } else if (typeof message === 'string') {
      eMsg = message;
    }
    return (
      <div style={{ backgroundColor: 'white' }}>
        <div className={styles.hedaer} style={{ backgroundColor: themeColor }}>
          <span className={styles.heading}>{heading}</span>
        </div>
        {!!errorConfMsg ?
          <div className={styles.message}>
            <span className={styles.errConfMsg}>{errorConfMsg}</span>
          </div>
          : null
        }
        <div className={styles.message}>
          <span className={styles.textAlignCenter}>{eMsg}</span>
        </div>
        <div className={styles.supportMessage}>
          <span className={styles.textAlignCenter}>{sMsg}</span>
        </div>
        <div className={styles.buttonsContainer}>
          {buttons.map((button, index) => (
            <Button
              key={`popup-button-${button.text}`}
              style={{
                background: 'white',
                flex: 1,
              }}
              onClick={button.onClick}
            >
              <span className={styles.buttonText} style={{ color: themeColor }}>{button.text}</span>
            </Button>
          ))}
        </div>
      </div>
    );
  }
  if (type === 'notification') {
    const { message, buttons } = props;
    return (
      <div>
        <div  className={styles.notificationMessage}  >
          <span style={{ textAlign: 'center' }}>{message}</span>
        </div>
        <div  className={styles.notificationButtons} >
          {buttons.map((button, index) => (
            <Button
              key={`popup-button-${button.text}`}
              style={{
                background: 'white',
                flex: 1,
                // borderRight: index !== buttons.length - 1 ? '1px solid black' : null,
              }}
              onClick={button.onClick}
            >
              <span className={styles.buttonText} style={{ color: themeColor }}>{button.text}</span>
            </Button>
          ))} 
        </div>
      </div>
    );
  }
  return null;
};
export default PopupContent;
